import { SiteMaterialAutocomplete, TradeCompanyAutocomplete, useFormContext, useWatch } from 'form';
import { useTranslation } from 'i18n';
import type { ComponentProps } from 'react';
import { Button, Stack } from 'ui';

type Props = {
  slotProps?: {
    tradeCompany?: ComponentProps<typeof TradeCompanyAutocomplete>;
    siteMaterial?: ComponentProps<typeof SiteMaterialAutocomplete>;
    siteMaterialAction?: ComponentProps<typeof Button>;
  };
};
export const TradeCompanySiteMaterialPicker = ({ slotProps }: Props) => {
  const { t } = useTranslation('features');
  const { control } = useFormContext();
  const tradeCompanyId = useWatch({ control, name: 'trade_company' });
  return (
    <>
      <TradeCompanyAutocomplete
        name="trade_company"
        label={t('siteMaterial.tradeCompanySiteMaterialPicker.labels.company')}
        required
        {...slotProps?.tradeCompany}
      />
      <Stack
        direction="column"
        sx={{
          alignItems: 'flex-end',
          justifyContent: 'center',
          width: '100%',
        }}
      >
        <Button
          variant="text"
          component="a"
          fullWidth={false}
          target="_blank"
          href={`/ground-control/v2/manage-company/${tradeCompanyId}/site-materials/new`}
          aria-label={t('siteMaterial.tradeCompanySiteMaterialPicker.actions.addNewMaterialAriaLabel')}
          disabled={!tradeCompanyId}
          data-testid="site-material-action"
          {...slotProps?.siteMaterialAction}
        >
          {t('siteMaterial.tradeCompanySiteMaterialPicker.actions.addNewMaterial')}
        </Button>
        <SiteMaterialAutocomplete
          name="trade_company_site_material"
          label={t('siteMaterial.tradeCompanySiteMaterialPicker.labels.siteMaterial')}
          disabled={!tradeCompanyId}
          tradeCompanyId={tradeCompanyId}
          required
          fullWidth
          disablePortal={false}
          data-testid="site-material-autocomplete"
          {...slotProps?.siteMaterial}
        />
      </Stack>
    </>
  );
};
